/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReservation201Response
 */
export interface CreateReservation201Response {
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateReservation201Response
     */
    dateTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateReservation201Response
     */
    endTime: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateReservation201Response
     */
    diners: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateReservation201Response
     */
    tables?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    customerComments: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    zone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    locationId: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateReservation201Response
     */
    creationTime: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    source: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReservation201Response
     */
    cancelled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    tabId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    externalId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    policy: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReservation201Response
     */
    policyAmount: number;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    policyMethod: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReservation201Response
     */
    policyCharged: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateReservation201Response
     */
    policyCancellationUntil?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateReservation201Response
     */
    status: string;
}

/**
 * Check if a given object implements the CreateReservation201Response interface.
 */
export function instanceOfCreateReservation201Response(value: object): value is CreateReservation201Response {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('surname' in value) || value['surname'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('diners' in value) || value['diners'] === undefined) return false;
    if (!('customerComments' in value) || value['customerComments'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('cancelled' in value) || value['cancelled'] === undefined) return false;
    if (!('tabId' in value) || value['tabId'] === undefined) return false;
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    if (!('policyAmount' in value) || value['policyAmount'] === undefined) return false;
    if (!('policyMethod' in value) || value['policyMethod'] === undefined) return false;
    if (!('policyCharged' in value) || value['policyCharged'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function CreateReservation201ResponseFromJSON(json: any): CreateReservation201Response {
    return CreateReservation201ResponseFromJSONTyped(json, false);
}

export function CreateReservation201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservation201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'surname': json['surname'],
        'phoneNumber': json['phoneNumber'],
        'dateTime': (new Date(json['dateTime'])),
        'endTime': (new Date(json['endTime'])),
        'diners': json['diners'],
        'tables': json['tables'] == null ? undefined : json['tables'],
        'customerComments': json['customerComments'],
        'zone': json['zone'],
        'email': json['email'],
        'locationId': json['locationId'],
        'creationTime': (new Date(json['creationTime'])),
        'source': json['source'],
        'cancelled': json['cancelled'],
        'tabId': json['tabId'],
        'externalId': json['externalId'],
        'policy': json['policy'],
        'policyAmount': json['policyAmount'],
        'policyMethod': json['policyMethod'],
        'policyCharged': json['policyCharged'],
        'policyCancellationUntil': json['policyCancellationUntil'] == null ? undefined : (new Date(json['policyCancellationUntil'])),
        'status': json['status'],
    };
}

export function CreateReservation201ResponseToJSON(json: any): CreateReservation201Response {
    return CreateReservation201ResponseToJSONTyped(json, false);
}

export function CreateReservation201ResponseToJSONTyped(value?: CreateReservation201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'phoneNumber': value['phoneNumber'],
        'dateTime': ((value['dateTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'diners': value['diners'],
        'tables': value['tables'],
        'customerComments': value['customerComments'],
        'zone': value['zone'],
        'email': value['email'],
        'locationId': value['locationId'],
        'creationTime': ((value['creationTime']).toISOString()),
        'source': value['source'],
        'cancelled': value['cancelled'],
        'tabId': value['tabId'],
        'externalId': value['externalId'],
        'policy': value['policy'],
        'policyAmount': value['policyAmount'],
        'policyMethod': value['policyMethod'],
        'policyCharged': value['policyCharged'],
        'policyCancellationUntil': value['policyCancellationUntil'] == null ? undefined : ((value['policyCancellationUntil'] as any).toISOString()),
        'status': value['status'],
    };
}

